

const overrideCardStyles = theme => ({
  MuiCard: {
    styleOverrides: {
      root: ({ elevation }) => ({
        boxShadow: elevation === 0 ? 'none' : theme.customShadows.card,
        borderRadius: Number(theme.shape.borderRadius) * 2,
        position: 'relative',
        zIndex: 0 // Fix Safari overflow: hidden with border radius
      })
    }
  },
  MuiCardHeader: {
    defaultProps: {
      titleTypographyProps: { variant: 'h6' },
      subheaderTypographyProps: { variant: 'body2' }
    },
    styleOverrides: {
      root: {
        padding: theme.spacing(3, 3, 0)
      }
    }
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: theme.spacing(3)
      }
    }
  }
})

export default overrideCardStyles